import React from 'react';
import { FaUserPlus, FaFileInvoiceDollar, FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import './how-it-works.css'; // Importing the final 3-color CSS file

const HowItWorks = () => {
    
    // Using the 3 strict colors for dynamic styling via colorCode
    const steps = [
        {
            stepNum: 1,
            icon: <FaUserPlus />,
            title: "1. Apply Securely Online",
            description: "Fill out your quick application. Encryption ensures your data remains protected from the first step.",
            accentClass: "step-accent-dark",
            colorCode: '#1a1a1a' // Dark
        },
        {
            stepNum: 2,
            icon: <FaFileInvoiceDollar />,
            title: "2. Instant Verification",
            description: "Our AI model instantly verifies your details and provides a quick loan decision with complete clarity and competitive terms.", // Longer description for testing equal height
            accentClass: "step-accent-green",
            colorCode: '#fbbf24' // Green
        },
        {
            stepNum: 3,
            icon: <FaCheckCircle />,
            title: "3. Funds Disbursed",
            description: "Once approved, the funds are instantly transferred directly to your bank account with zero hassle.",
            accentClass: "step-accent-magenta",
            colorCode: '#0ea5a4' // Magenta
        },
    ];

    return (
        <section className="how-it-works-section three-color-design">
            <div className="container how-it-works-container">
                 <h2 className="trust-section-heading">
                   The <span className="accent-green-mv">Fast</span> -<span className="accent-magenta-mv">Track</span> Process
                </h2>
                <p className="how-it-works-subtitle">
                    Experience our streamlined, three-step journey to quick and ethical financing.
                </p>
                
                <div className="stepper-flow-wrapper">
                    {steps.map((step, index) => (
                        <React.Fragment key={index}>
                            {/* Passing colorCode as CSS variable for dynamic hover glow */}
                            <div className="flow-step" style={{ '--accent-color': step.colorCode }}>
                                <div className={`step-circle ${step.accentClass}`}> 
                                    <div className="step-icon">{step.icon}</div>
                                    <span className="step-number">{step.stepNum}</span>
                                </div>
                                <h3 className="step-title">{step.title}</h3>
                                <p className="step-description">{step.description}</p>
                            </div>
                            {/* Arrow connector between steps */}
                            {index < steps.length - 1 && (
                                <div className="flow-arrow-connector">
                                    <FaArrowRight />
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <div className="section-divider-how-it-works"></div>
        </section>
    );
};

export default HowItWorks;